<iframe [src]="url$ | async">

</iframe>